import { memberGQLFields } from '../network/member.fields.js';
const BASIC_SPACE_JOIN_REQUEST_FIELDS = {};
const ALL_SPACE_JOIN_REQUEST_FIELDS = {
    member: 'basic',
};
export const spaceJoinRequestGQLFields = (fields) => {
    if (fields === 'basic')
        fields = BASIC_SPACE_JOIN_REQUEST_FIELDS;
    if (fields === 'all')
        fields = ALL_SPACE_JOIN_REQUEST_FIELDS;
    return `
    id
    spaceId
    status
    ${fields.member
        ? `
      member {
        ${memberGQLFields(fields.member)}
      }
    `
        : ``}
  `;
};
//# sourceMappingURL=spaceJoinRequest.fields.js.map